import React from 'react';

export default function DefaultTabAddTile({ title, tabIndex = 0 }) {
  return (
    <div className="md-tile-container">
      <a
        className="md-tile"
        tabIndex={tabIndex}
        aria-label={title}
        title={title}>
          <div className="md-tile-inner">
            <div className="md-icon md-icon-background">
              <div className="md-icon-background">
                <div className="md-add-icon">
                </div>
              </div>
            </div>
            <div className="md-title-container">
              <div
                className="md-title"
                style={{ direction: 'ltr' }}>
                  <span>{title}</span>
              </div>
            </div>
          </div>
      </a>
    </div>
  )
}
